<template>
  <InputValidator
    :config="{
      attribute: getAttribute(),
      inputClass: getStyleClass(),
      label: control.label,
      name: control.label,
      maxlength: control.maxlength,
      placeholder: control.placeholder,
      readonly: control.readonly,
      required: !!control.required,
      type: type,
      value: value,
      validate: validators,
    }"
    :tooltip="getTooltip()"
    @InputValidatorModel="(value) => handleInputChange(value, $validator)"
  />
</template>

<script>
import { get } from 'lodash';
import DynamicControlsMixin from 'components/DynamicControls/mixins/DynamicControlsMixin';
import InputValidator from 'client/components/FormValidation/InputValidator.vue';

export default {
  name: 'DynamicControlsInput',

  inject: ['$validator'],

  components: {
    InputValidator,
  },

  mixins: [
    DynamicControlsMixin,
  ],

  props: {
    sensitive: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    isRightAligned() {
      const alignment = get(this.control, 'displayOptions.alignment', '');
      return alignment === 'right';
    },

    type() {
      return this.sensitive ? 'password' : 'text';
    },

    validators() {
      if (this.control.validators) {
        return this.control.validators;
      }

      return this.control.required ? this.control.required : '';
    },
  },

  methods: {
    getAttribute() {
      return this.control.attribute || '';
    },

    getStyleClass() {
      let assignedStyle = '';
      if (this.isRightAligned) {
        assignedStyle = this.$style.rightAlignment;
      }
      return assignedStyle;
    },
  },
};
</script>
<style module>

  .rightAlignment {
    direction: ltr;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .rightAlignment:not(:focus) {
    direction: rtl;
    text-align: right;
    text-overflow: ellipsis;
    unicode-bidi: plaintext;
  }
</style>
